import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { PortalUser, UserService } from './portal/user/portal-user.service';
import { Subscription } from 'rxjs';
import { UserInterfaceService } from './services/user-interface.service';

@Component({
    templateUrl: './no-usage-right.component.html',
    styleUrls: ['./no-usage-right.component.scss']
})
export class NoUsageRightComponent implements OnInit, OnDestroy {
    // Selectable users for showing admins contact list.
    public portalUsers: PortalUser[] = [];
    public showAdmins: boolean = false;
    public mobile: boolean = false;
    private subscriptions: Array<Subscription> = [];

    constructor(
        private userService: UserService,
        private userInterfaceService: UserInterfaceService,
        private cdRef: ChangeDetectorRef,
    ) { }

    /**
     * onInit
     : void*/
    public ngOnInit(): void {
        // Observe device screen size and change the layout accordingly
        this.subscriptions.push(
            this.userInterfaceService.mobile$.subscribe((state: boolean) => {
                this.mobile = state;
                this.cdRef.detectChanges();
            })
        );
        // Get portal users
        this.userService.getCompanyUsers().subscribe((users) => {
            this.portalUsers = users.filter(user => user.Role == '10');
            this.showAdmins = this.portalUsers.length > 0;
        });
    }
    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    }
}
